import { createClient } from '@supabase/supabase-js';

// These are meant to be public — the anon key only allows what your
// Supabase Row Level Security rules permit, unlike the service role key
// which must never be shipped to the browser.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
